'use strict';

var processInclude = require('base/util');

var formValidation = require('base/components/formValidation');
var createErrorNotification = require('base/components/errorNotification');
var recaptcha = require('core/components/recaptcha');

/**
 * A list of base Files, leave these in order they are listed
 */
var baseFiles = {
    login: require('core/login/login')
};

baseFiles.login.register = function () {
    $('form.registration').submit(function (e) {
        var form = this;
        var $form = $(form);
        var timeout = $form.data('timeout') || 20000; //default timeout (increased on retry)
        var defer = $form.data('defer');

        e.preventDefault();

        // Cancel Ajax
        if ($form.hasClass('csrf-used')) return false;

        // Stop recaptcha promise chain and prevent AJAX
        defer?.state?.() !== 'resolved' && defer?.reject();

        // Copy the email field to the email confirm field
        $form.find('[name=dwfrm_profile_customer_emailconfirm]').val(
            $form.find('[name=dwfrm_profile_customer_email]').val()
        );

        $form.data('defer', recaptcha.check(e, {
            url: $form.attr('action'),
            type: 'post',
            dataType: 'json',
            data: $form.serialize(),
            timeout: timeout,
            beforeSend: function ($xhr, settings) {
                $form.addClass('csrf-used');
                $form.data('timeout', timeout * 1.5);
                $form.spinner().start();
            },
            success: function (data) {
                if (data?.success !== true) {
                    $form.trigger('login:register:error', data);
                    formValidation(form, data);
                    $form.spinner().stop();
                    $form.removeClass('csrf-used');
                } else {
                    $form.trigger('login:register:success', data);
                    location.href = data.redirectUrl;
                }
            },
            error: function (err) {
                if (err?.responseJSON?.redirectUrl) {
                    location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification($('.error-messaging'), err?.responseJSON?.errorMessage);
                    $form.trigger('login:register:error', err);
                    $form.spinner().stop();
                    $form.removeClass('csrf-used');
                }
            }
        }));

        // Move to after Ajax initialization, still triggered if an AJAX request was started but not if ajax call is malformed
        $form.trigger('login:register', e);
    });
};

$(document).ready(function () {
    Object.keys(module.exports.baseFiles).forEach(function (key) {
        processInclude(module.exports.baseFiles[key]);
    });
});


module.exports = {
    baseFiles
};
